import React, { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router';
import { Summary as OrderSummary, StepName } from '|/app/services';
import * as Summary from '|/app/steps/order-summary/order-summary-components.styles';
import phone from '|/helpers/phone';
import useOrderSummaryVm from '|/helpers/use-order-summary';
import SummaryContext from '../../../../summary-context';
import StepUrlsContext from '../../../step-urls-context';

const defaultProps = {
  summary: {} as OrderSummary
};

const AccountDetailsSection = ({ summary } = defaultProps) => {
  const { setShowSummary } = useContext(SummaryContext);
  const { stepUrlMap } = useContext(StepUrlsContext);
  const navigate = useNavigate();
  const redirectTo = useCallback(() => {
    setShowSummary(false);
    navigate(`/steps/${stepUrlMap[StepName.PersonalDetails]}/entry`);
  }, [setShowSummary, navigate, stepUrlMap]);
  const {
    hasAddress: showEdit,
    hasPii,
    customerName: name,
    phoneNumber,
    emailAddress,
    customerLine1: line1,
    customerLine2: line2,
    customerCity: city,
    customerState: state,
    customerZipCode: zipCode
  } = useOrderSummaryVm(summary);

  return (
    <Summary.Section>
      <Summary.Heading>Account Details</Summary.Heading>

      {!hasPii && (
        <Summary.Box>
          <Summary.BoxText>
            * We still need your personal information
          </Summary.BoxText>
        </Summary.Box>
      )}

      {hasPii && (
        <Summary.Box>
          <Summary.List>
            <Summary.SummaryListItem label="Legal Name" value={name} />
            <Summary.SummaryListItem
              label="Mobile Number"
              value={phone(phoneNumber || '') ?? ''}
            />
            {emailAddress && (
              <Summary.SummaryListItem
                label="Email Address"
                value={emailAddress}
                breakAll
              />
            )}
          </Summary.List>
          <Summary.BoxLabel style={{ margin: '24px 0 16px' }}>
            Home Address
          </Summary.BoxLabel>
          <Summary.List>
            {!line1 && !line2 && (!city || !state || !zipCode) && (
              <Summary.BoxText>
                * We still need your address information
              </Summary.BoxText>
            )}
            {line1 && <Summary.SummaryListItem label="Street" value={line1} />}
            {line2 && (
              <Summary.SummaryListItem label="Street 2" value={line2} />
            )}
            {city && state && zipCode && (
              <Summary.SummaryListItem
                label="City, State, ZIP"
                value={`${city}, ${state} ${zipCode}`}
              />
            )}
          </Summary.List>
        </Summary.Box>
      )}

      {showEdit && (
        <Summary.EditButton
          onClick={redirectTo}
          data-analytics-id="pp_order_summary_edit_account"
        >
          Edit Account Details
        </Summary.EditButton>
      )}
    </Summary.Section>
  );
};

export default AccountDetailsSection;
